import { memo } from 'react';
import { Button, Dropdown } from 'antd';
import { EllipsisDots } from '@/assets/icons';
import { useToggle } from '@/hooks';
import { cn } from '@/libs/utils';
import { isFunction } from '@/utils/utils';

const DropdownContent = memo(({ children, open, onClose }) => {
  return isFunction(children) ? children({ open, onClose }) : children;
});

DropdownContent.displayName = 'DropdownContent';

export default function ActionsDropdown({
  children,
  className,
  metadata,
  triggerButton,
}) {
  const { open, onToggle, onClose } = useToggle(false);

  const renderDropdownContent = (
    <div
      className={cn(
        'min-w-[140px] rounded-md border-[3px] border-accent bg-white p-2 shadow-md',
        className
      )}
    >
      <DropdownContent open={open} onClose={onClose}>
        {children}
      </DropdownContent>
    </div>
  );

  return (
    <Dropdown
      open={open}
      onOpenChange={onToggle}
      placement="bottomRight"
      trigger={['click']}
      overlayStyle={{ zIndex: 1000, ...metadata?.overlayStyle }}
      popupRender={() => renderDropdownContent}
    >
      {triggerButton ? (
        triggerButton
      ) : (
        <Button
          type="default"
          className={cn(
            'btn-default-action h-8 w-8',
            metadata?.buttonClassName
          )}
        >
          <EllipsisDots
            className={cn(
              'transition-transform duration-150',
              open ? 'rotate-90' : ''
            )}
          />

          <span className="sr-only">Actions</span>
        </Button>
      )}
    </Dropdown>
  );
}
